import styled from "styled-components";
import {
  BREAKPOINTS,
  COLORS,
  TYPOGRAPHY
} from "containers/impact-report/constants";
import { defaultFont } from "src/nhweb-shared/theme/fonts";

export const Section = styled.section`
  width: 100%;
  background: ${COLORS.WHITE};
  padding: 60px 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 100px 40px;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1030px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.H2_DESKTOP}
    text-align: center;
  }
`;

export const DropdownWrapper = styled.div`
  max-width: 288px;
  margin: 16px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    margin: 16px auto;
  }
`;

export const LastUpdated = styled.p`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 8px 0 30px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
    text-align: center;
    margin: 8px 0 80px 0;
  }
`;

export const MetricsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 40px;
  }
`;

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${BREAKPOINTS.MD}) {
    flex: 1;
    align-items: center;
    text-align: center;
  }
`;

export const MetricNumber = styled.div`
  font-family: ${defaultFont};
  font-size: 64px;
  font-weight: 500;
  line-height: 1;
  color: ${COLORS.PRIMARY_BASE};
  margin-bottom: 8px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    font-size: 128px;
  }
`;

export const MetricLabel = styled.div`
  ${TYPOGRAPHY.H1_MOBILE}
  color: ${COLORS.NEUTRAL_500};

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.HEADING_NORMAL_MEDIUM}
  }
`;
